import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CompanypagesService } from "src/app/_services/companypages.service";
import { environment } from "src/environments/environment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LocalStorageService } from "src/app/_services/local-storage.service";
import {Title} from "@angular/platform-browser";
import { Clipboard } from '@angular/cdk/clipboard';


@Component({
  selector: "app-companyinfo",
  templateUrl: "./companyinfo.component.html",
  styleUrls: ["./companyinfo.component.scss"],
})
export class CompanyinfoComponent implements OnInit {
  companyId;
  companyName = "";
  basicInfo = {};
  emplList;
  postLoginUrl = "";
  devUrl = environment.backendurl;
  showtab = 0 // 0->employee details, 1->salary details
  similarCompanies = [];
  modalContent = 0; //0->Signup, 1->login, 2->OTP
  expandEmpList: boolean = false;
  industry = "";
  successMessage = "";
  errorMessage = "";
  isLoading = false;
  currentUnlockedUser = '';
  showEmptyState: boolean = false;
  industryid;
  companyRevenue;

  //emplist
  country = "";
  city = "";
  jobtitle = "";
  gettopjobtitles: boolean = true;
  countryList = [];
  cityList = [];
  jobTitleList = [];
  filteredJobTitleList = [];
  paginationOffset = 20;
  start = 0;
  end = 20;
  totalCount = 0;
  usernumber = 0;
  paginationArray = [];
  activePage = 0;
  prevPage = 1;
  timeout;
  salaryList = [];
  showSalaryWidget: boolean = false;

  //filters
  location = "india";
  currency = "USD";
  currencyList = [];
  locationsList = [];
  filterApplied: boolean = false;

  dataSourceFunctions: any = {};
  dataSourceGender: any = {};

  userid;
  teamid;

  showtext:boolean=true;

  constructor(
    private _Activatedroute: ActivatedRoute,
    private _companypagesservice: CompanypagesService,
    private modalService: NgbModal,
    private localstorageservice: LocalStorageService,
    private titleService:Title,
    private clipboard: Clipboard
  ) {}

  ngOnInit(): void {
    this.companyId = this._Activatedroute.snapshot.paramMap.get("cid");
    this.companyName = this._Activatedroute.snapshot.paramMap.get("cname");
    this.userid = this.localstorageservice.getItem('userid');
    this.teamid = this.localstorageservice.getItem('teamid');
    this.usernumber = this.localstorageservice.getItem('usernumber');
    this.getSalaryData();
    this._companypagesservice
      .getCompanyInfo(this.companyId)
      .subscribe((data: any) => {
        if(data.status == "success"){
          this.basicInfo = data.basicInfo;
          this.similarCompanies = data.similarCompanies;
          this.industry = data?.basicInfo?.industry;
          this.industryid = data?.basicInfo?.industryid;
          this.companyRevenue = data?.basicInfo?.companyrevenueinusd
          this.companyRevenue = this._companypagesservice.numberWithCommas(this.companyRevenue);
          this.dataSourceFunctions = {
            chart: {
              caption: "Functions",
              yAxisName: "% of Employees",
              xAxisName: "Function Name",
              theme: "fusion",
            },
            categories: data.categories,
            dataset: data.dataset
          };
  
          this.dataSourceGender = {
            chart: {
              caption: "Gender",
              plottooltext: "<b>$percentValue</b> of employees are $label",
              numberPrefix: "$",
              showPercentInTooltip: "0",
              decimals: "1",
              useDataPlotColorForLabels: "1",
              theme: "fusion",
            },
            data: data.genderData,
          };
        } else{
          this.showEmptyState = true;
        }
      });

    this.getEmpList(0,5);
    this.postLoginUrl = `/company-directory/${this.companyName}/${this.companyId}`;
  }

  getEmpList(start, end) {
    end = this.expandEmpList?end:5;
    this._companypagesservice
      .getCompanyEmpList(
        this.companyId,
        start,
        end,
        this.city,
        this.country,
        this.jobtitle,
        this.gettopjobtitles
      )
      .subscribe((res: any) => {
        let data = res.message;
        if (this.gettopjobtitles) {
          this.emplList = data;
          this.totalCount = data.totalCount;
          this.countryList = data.countryList;
          this.cityList = data.cityList;
          this.jobTitleList = data.finalJobTitles;
          this.filteredJobTitleList = data.finalJobTitles.slice(0,10);
          this.paginationArray = data.pagesArray;
        } else {
          this.emplList = data;
          this.totalCount = data.totalCount;
          this.countryList = data.countryList;
          this.cityList = data.cityList;
          this.paginationArray = data.pagesArray;
        }
        if (this.totalCount < this.end) {
          this.end = this.totalCount;
        }
        this.emplList.message.forEach(emp => {
          emp.enricheddetails.socialprofilesarray.forEach(item => {
            item = this.addFontAwesomeLink(item);
          })
        })
      });
  }

  pagination(type, load=0) {
    let callApi = true;
    switch (type) {
      case "next":
        this.start += this.paginationOffset;
        this.end += this.paginationOffset;
        if (this.end > this.totalCount){
          this.end = this.totalCount;
          callApi = false;
        }
        if (this.start > this.end) this.start -= this.paginationOffset;
        break;

      case "prev":
        this.end = this.start;
        this.start -= this.paginationOffset;
        if (this.start < 0) {
          this.start = 0;
          this.end = this.paginationOffset;
          callApi = false;
        }
        break;


      case "page":
        if(load != this.prevPage){
          this.prevPage = load;
          let pageNum;
          pageNum = this.activePage - 1;
          this.start = pageNum*this.paginationOffset;
          this.end = this.start + this.paginationOffset;
        } else {
          callApi = false;
        }
        break;
    }
    if(callApi){
      this.getEmpList(this.start, this.end);
    }
  }

  sanitizeValues(val) {
    if (val) {
      if (val.toLowerCase() == "null") return '';
      else return val;
    } else return '';
  }

  switchTab(val){
    this.showtab = val ? val:0;
  }

  openModal(content){
    this.modalService.open(content, { centered: true });
  }

  switchEmpListView(val){
    this.expandEmpList = val;
    if(!val){
      this.getEmpList(0,5)
    } else{
      this.getEmpList(0,20);
    }
  }

  applyFilter(type, event) {
    if (type == "city") {
      this.city = event;
      this.gettopjobtitles = true;
      this.filterApplied = true;
    } else if (type == "country") {
      this.country = event;
      this.city = "";
      this.gettopjobtitles = true;
      this.filterApplied = true;
    } else if (type == "jobtitle") {
      this.jobtitle = event.toLowerCase();
      this.gettopjobtitles = false;
      this.filterApplied = true;
    } else if (type == "clearall") {
      if(this.filterApplied){
        this.city = "";
        this.country = "";
        this.jobtitle = "";
        this.gettopjobtitles = true;
        this.start = 0;
        this.end = this.paginationOffset;
        this.getEmpList(this.start, this.end);
        this.filterApplied = false;
      }
    }

    this.start = 0;
    this.end = this.paginationOffset;
    if(this.filterApplied){
      this.getEmpList(this.start, this.end);
    }
  }

  onKeyPress(val){
    this.filterApplied = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.getTypeaheads(val);
    },500);
  }

  getTypeaheads(val){
    val = val.toLowerCase();
    this.filteredJobTitleList = this.jobTitleList.filter(item => item.includes(val));
  }

  unlockCandidate(empDetails){
    this.isLoading = true;
    this.currentUnlockedUser = empDetails.createdcandidatenumber;
    let body = {}, iter = 0;
    let locationname = '', profileurl = '', profileArr = [], platformname = '';
    locationname = empDetails.workcity?empDetails.workcity:empDetails.city?empDetails.city:'';
    locationname+= " ";
    locationname+= empDetails.workcountry?empDetails.workcountry:empDetails.country?empDetails.country:'';
    if(empDetails.enricheddetails?.socialprofilesarray?.length>0){
      profileArr = empDetails.enricheddetails?.socialprofilesarray;
      for(iter = 0; iter<profileArr.length; iter++){
        if(profileArr[iter].platformname){
          profileurl = profileArr[iter].link;
          platformname = profileArr[iter].platformname;
          break;
        }
      }
    }
    body = {
      firstname: empDetails.firstname,
      middlename: null,
      lastname: empDetails.lastname,
      locationname,
      jobtitle: empDetails.jobtitle,
      companyname:this.companyName,
      industryname: this.industry,
      source: 'companypages',
      companypage_candidatenumber: empDetails.createdcandidatenumber,
      usernumber: this.usernumber,
      profileurl,
      platformname
    }
    this._companypagesservice.getEnrichedData(body).subscribe((res: any) => {
      if(res.status === 'success'){
        empDetails.enricheddetails.emailsarray = res.data.enricheddetails.emailsarray;
        empDetails.enricheddetails.socialprofilesarray = res.data.enricheddetails.socialprofilesarray;
        empDetails.enricheddetails.contactnumbersarray = res.data.enricheddetails.contactnumbersarray;
        if(empDetails && empDetails.enricheddetails && empDetails.enricheddetails.socialprofilesarray){
          empDetails.enricheddetails.socialprofilesarray.forEach(item => {
            item = this.addFontAwesomeLink(item);
          })
        }
        this.emplList.message.forEach(item => {
          if(item.createdcandidatenumber == empDetails.createdcandidatenumber){
            item.enricheddetails = empDetails.enricheddetails;
            item['unlocked'] = true;
          }
        })
        this.toastmessage(res.message,'success');
      } else if(res.err){
        this.toastmessage(res.err,'error');
      } else if(res.status == 'failure' && res.message) {
        this.toastmessage(res.message, 'error');
      } else {
        this.toastmessage('Something went wrong', 'error');
      }
      this.isLoading = false;
      this.currentUnlockedUser = '';
    })
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }
  showfullText(){
    this.showtext = !this.showtext
  }

  copyText(textToCopy: string, type) {
    this.clipboard.copy(textToCopy);
    if(type == 'email'){
    this.toastmessage('Email copied succesfully','success');
    }else if(type == 'contact'){
    this.toastmessage('Contact copied succesfully','success');
    }
  }

  addFontAwesomeLink(item){
    if(item.platformname == 'linkedin'){
      item['icon'] = 'fab fa-linkedin-in'
    }
    if(item.platformname == 'medium'){
      item['icon'] = 'fab fa-medium'
    }
    if(item.platformname == 'twitter'){
      item['icon'] = 'fab fa-twitter'
    }
    if(item.platformname == 'facebook'){
      item['icon'] = 'fab fa-facebook-square'
    }
    if(item.platformname == 'instagram'){
      item['icon'] = 'fab fa-instagram'
    }
    if(item.platformname == 'github'){
      item['icon'] = 'fab fa-github-square'
    }
    if(item.platformname == 'behance'){
      item['icon'] = 'fab fa-behance-square'
    }
    if(item.platformname == 'dribbble'){
      item['icon'] = 'fab fa-dribbble'
    }
    return item;
  }

  getSalaryData(){
    this._companypagesservice.getCompanyExpAndSal(this.companyId,0,5,'','USD','',false,5).subscribe((data:any) => {
      if(data && data.status == 'success'){
        this.salaryList = data.finalData;
        this.salaryList.forEach((item: any) => {
          item.finalSalary = this._companypagesservice.numberWithCommas(item.finalSalary)
        });
        if(data.totalSalaryData>0){
          this.showSalaryWidget = true;
        }
      }
    })
  }
}
